<script setup lang="ts">
import { cn } from '@pkg/ui/lib/utils';

withDefaults(defineProps<{
  availability?: boolean;
  oldPrice?: string;
  currentPrice?: string;
  alignRight?: boolean;
}>(), {
  oldPrice: '0',
  currentPrice: '0',
  alignRight: false,
});
</script>

<template>
  <p
    :class="cn('s-detail__header__price s-detail__header__price--tablet', {
      's-detail__header__price--unavailable': !availability,
      's-detail__header__price--right': alignRight,
    })"
  >
    <span class="s-detail__header__price--old">{{ oldPrice }}</span>
    <span class="">{{ currentPrice }}</span>
  </p>
</template>

<style scoped>
@import '~/assets/css/mixins/_mixins.index.pcss';

.s-detail__header__price {
  @mixin h5-tenon;
  font-weight: bold;
  display: flex;
  align-items: center;
  flex: 25%;

  &--unavailable {
    opacity: 0.5;
  }

  &--old {
    @mixin body-small;
    text-decoration: line-through;
    color: theme('colors.neutral.70');
    margin-right: theme('margin.8');
  }

  &--tablet {
    @screen tablet {
      display: flex;
      align-content: center;
      justify-content: center;
    }
  }

  &--right {
    justify-content: flex-end;
  }
}
</style>
